import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the recordControlPanel state domain
 */

const selectRecordControlPanelDomain = (state) =>
  state.get("recordControlPanel", initialState)

/**
 * Other specific selectors
 */
export const makeSelectFileHistories = () =>
  createSelector(selectRecordControlPanelDomain, (state) =>
    state.get("fileHistories")
  )

export const makeSelectIsLoadingFileHistories = () =>
  createSelector(selectRecordControlPanelDomain, (state) =>
    state.get("isLoadingFileHistores")
  )
/**
 * Default selector used by RecordControlPanel
 */

const makeSelectRecordControlPanel = () =>
  createSelector(selectRecordControlPanelDomain, (substate) => substate.toJS())

export default makeSelectRecordControlPanel
export { selectRecordControlPanelDomain }
